import { isEmpty } from 'ramda';
import { createSelector } from 'reselect';

import { lastBetsSelector, totalBetSelector } from './bet';
import { allowWinBellowBetSelector } from './config';
import { canPlaceBetsSelector, winAmountSelector } from './round';
import { userBalanceSelector } from './user';

export const canRebetSelector = createSelector(
  canPlaceBetsSelector,
  lastBetsSelector,
  userBalanceSelector,
  (canPlaceBets, lastBets, balance) => canPlaceBets && lastBets
  && !isEmpty(lastBets) && lastBets.totalBet <= balance
);

export const noWinBelowBetSelector = createSelector(
  allowWinBellowBetSelector,
  totalBetSelector,
  winAmountSelector,
  (noWinBelowBet, totalBet, totalWin = 0) => totalWin > 0 && (totalBet < totalWin || !noWinBelowBet)
);
